import React from 'react'
import cn from 'classnames'

import s from 'components/Common/StaticRadioInput.module.css'

const StaticRadioInput = ({ checked }) => <div className={cn(s.radio, { [s.checked]: checked })} />

export default StaticRadioInput
